import React, { useState, useEffect } from 'react';
import { FaEdit } from 'react-icons/fa'; // Importing edit icon from react-icons
import SummaryApi from '../common';
import { toast } from 'react-toastify';

const AdminNotificationBar = () => {
    const [barMessage, setBarMessage] = useState('! مرحبا بكم في دواكو');
    const [isEditing, setIsEditing] = useState(false);
    const [newMessage, setNewMessage] = useState('! مرحبا بكم في دواكو'); 

    const fetchBarMessage = async () => {
        try {
            const response = await fetch(SummaryApi.getBarMessage.url, {
                method: SummaryApi.getBarMessage.method,
                credentials: 'include',
                headers: {
                    "Content-Type": 'application/json'
                }
            });
            const responseData = await response.json();
            setBarMessage(responseData?.data);
            setNewMessage(responseData?.data?.at(0)?.word);
        } catch (error) {
        }
    };

    useEffect(() => {
        fetchBarMessage();
    }, []);

    const handleEditClick = () => {
        setIsEditing(true);
    };

    const handleSaveClick = async () => {
        try {
            const response = await fetch(SummaryApi.updateBarMessage.url, {
                method: SummaryApi.updateBarMessage.method,
                credentials: 'include',
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({ newMessage }) 
            });

            const responseData = await response.json();
    
            if (responseData.success) {
                setIsEditing(false);
                toast.success('تم تعديل رسالة الإشعارات بنجاح');
                fetchBarMessage();
            } else {
                setIsEditing(false);
                toast.error('حدث خطأ أثناء تعديل رسالة الإشعارات');
                fetchBarMessage();
            }
        } catch (error) {
            setIsEditing(false);
            toast.error('حدث خطأ أثناء تعديل رسالة الإشعارات');
        }
    };

    const handleCancelClick = () => {
        setIsEditing(false);
        setNewMessage(barMessage?.at(0)?.word); // Reset newMessage to current barMessage
    };

    return (
        <div className="bg-blue-900 text-white p-2 flex items-center justify-between">
            <div className="flex-grow text-center"> 
                {isEditing ? (
                    <input
                        type="text"
                        value={newMessage}
                        onChange={(e) => setNewMessage(e.target.value)}
                        className="border rounded p-1 text-black"
                    />
                ) : (
                    <span>{barMessage?.at(0)?.word}</span>
                )}
            </div>
            <div className="flex items-center space-x-4"> 
                {isEditing ? (
                    <>
                        <button 
                            onClick={handleSaveClick} 
                            className="ml-2 text-white border border-green-500 rounded px-3 py-1 hover:bg-green-500 hover:text-white"
                        >
                            حفظ
                        </button>
                        <button 
                            onClick={handleCancelClick} 
                            className="ml-2 text-white border border-red-500 rounded px-3 py-1 hover:bg-red-500 hover:text-white"
                        >
                            إلغاء
                        </button>
                    </>
                ) : (
                    <FaEdit onClick={handleEditClick} className="cursor-pointer text-white" />
                )}
            </div>
        </div>
    );
};

export default AdminNotificationBar;
